import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface LoginDiagnostics {
  timestamp: string;
  authType: string;
  callSite?: string; // Unique identifier for where this diagnostic was triggered from
  networkType: string | null;
  networkAvailable: boolean;
  networkSwitching: boolean;
  retriesUsed: number;
  maxRetries: number;
  success: boolean;
  platform: string;
  osVersion?: string;
  modelName?: string;
  hadCachedProfile?: boolean;
  refreshTokenValid?: boolean;
  accessTokenValid?: boolean;
  error?: string;
}

@Component({
  selector: 'app-login-diagnostics-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './login-diagnostics-modal.component.html',
  styleUrl: './login-diagnostics-modal.component.scss'
})
export class LoginDiagnosticsModalComponent {
  constructor(
    public dialogRef: MatDialogRef<LoginDiagnosticsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LoginDiagnostics
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  copyToClipboard(): void {
    const diagnosticsText = JSON.stringify(this.data, null, 2);
    navigator.clipboard.writeText(diagnosticsText).then(() => {
      alert('Diagnostics copied to clipboard');
    });
  }
}
